import slice from './App.slice';

export const { fetchInitialized, setInitialized } = slice.actions;